import { Row, Link } from 'components/Blocks';
import { LogoIcon } from 'components/Icons';

import { Notifications } from './Notifications';
import { UserMenu } from './UserMenu';
import { HeaderSideBarButton } from './SideBarButton';
import { ColorModeButton } from './ColorMode';
import { ProjectSearch } from './ProjectSearch';

export function Header(): JSX.Element {
  return (
    <Row
      as="header"
      justifyContent="space-between"
      fullWidth
      className="z-10 px-4 py-1.5 shadow-md dark:border-b"
    >
      <Row gap="2">
        <HeaderSideBarButton />

        <Link
          to="home"
          className="flex items-center gap-2 dark:text-muted-foreground"
          draggable={false}
        >
          <LogoIcon className="phone:!size-8" size={42} />

          <span className="select-none text-xl font-semibold phone:text-lg small_phone:hidden">
            OPERATIONS
          </span>
        </Link>
      </Row>

      <Row>
        <ProjectSearch />

        <ColorModeButton />

        <Notifications />

        <UserMenu />
      </Row>
    </Row>
  );
}
